import React, { useEffect } from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../theme/theme-provider';
import ThemeAmbientOverlay from '../theme-ambient-overlay/ThemeAmbientOverlay';

const NotFound = ({ sendPage }) => {
  const navigate = useNavigate();
  const { themeMode } = useTheme();
  const isDark = themeMode === 'dark';
    const headerColor = isDark ? 'white' : 'rgba(22,22,22,0.94)';
    const headerShadow = isDark ? '4px 4px black' : '2px 2px rgba(255,255,255,0.65)';

  useEffect(() => {
    if (sendPage) {
      sendPage('not-found');
    }
    window.scrollTo(0, 0);
  }, [sendPage]);

  return (
    <Box
      sx={{
        backgroundColor: 'var(--background-color)',
        minHeight: '100vh',
        py: { xs: 8, md: 12 },
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <ThemeAmbientOverlay speed={30} />
      <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 2 }}>
        <Box
          sx={{
            position: 'relative',
            border: isDark ? '1px solid rgba(242, 211, 153, 0.25)' : '1px solid rgba(0,0,0,0.1)',
            boxShadow: isDark ? '0 12px 30px rgba(0,0,0,0.25)' : '0 10px 24px rgba(0,0,0,0.12)',
            borderRadius: 2,
            p: { xs: 3, md: 4 },
            textAlign: 'center',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: isDark
                ? 'linear-gradient(90deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.7) 15%, rgba(0,0,0,0.7) 85%, rgba(0,0,0,0.05) 100%)'
                : 'linear-gradient(90deg, rgba(255,250,244,0.1) 0%, rgba(255,250,244,0.92) 15%, rgba(255,250,244,0.92) 85%, rgba(255,250,244,0.1) 100%)',
              backdropFilter: 'blur(8px)',
              borderRadius: 2,
              zIndex: -1
            }
          }}
        >
          <Typography
            variant="h2"
              color={headerColor}
            sx={{
              fontFamily: 'Light-1',
                textShadow: headerShadow,
              fontSize: { xs: '2rem', sm: '2.4rem', md: '2.8rem' },
              mb: 2
            }}
          >
            404
          </Typography>

          <Typography
            color={isDark ? 'white' : 'rgba(0,0,0,0.82)'}
            sx={{ fontFamily: '"Courier New", monospace', lineHeight: 1.8, mb: 3 }}
          >
            This page was not found or does not exist.
          </Typography>

          <Button
            variant="contained"
            onClick={() => navigate('/')}
            sx={{
              fontFamily: '"Courier New", monospace',
              fontWeight: 'bold',
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              px: 2.2,
              py: 1,
              borderRadius: '8px',
              border: isDark ? '1px solid rgba(242, 211, 153, 0.55)' : '1px solid #111111',
              backgroundColor: isDark ? 'rgba(255,255,255,0.08)' : 'black',
              color: isDark ? 'rgba(255,255,255,0.95)' : '#F2D399',
              boxShadow: '0 8px 20px rgba(0,0,0,0.35)',
              '&:hover': {
                color: 'black',
                backgroundColor: isDark ? 'rgba(242, 211, 153, 0.9)' : 'white',
                transform: 'translateY(-1px)'
              }
            }}
          >
            Go Home
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default NotFound;
